import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { AdminPanel } from "../../components/admin/AdminPanel";
import { AdminTable } from "../../components/admin/AdminTable";
import { Badge } from "../../components/ui/Badge";
import { EmptyState } from "../../components/ui/EmptyState";
import { FullPageLoader } from "../../components/ui/FullPageLoader";
import { useTeamMembers } from "../../hooks/useTeamMembers";
import { useTenant } from "../../hooks/useTenant";
import { formatDateTime, statusTone, titleCase } from "../../lib/format";

export function TrainerTeamPage() {
  const { currentTenant, currentRole } = useTenant();
  const { data, loading, error } = useTeamMembers(currentTenant?.id);

  return (
    <div>
      <AdminPageHeader title="Team" description="People with access to this workspace." />
      <AdminPanel title="Workspace members">
        {currentRole === "tenant_owner" ? (
          <p className="mb-5 text-sm leading-6 text-graphite/70">
            Team invites are still controlled from platform admin while we keep the invite flow server-controlled.
          </p>
        ) : null}
        {loading ? <FullPageLoader label="Loading team" /> : null}
        {error ? <EmptyState title="Unable to load team.">{error}</EmptyState> : null}
        {!loading && !error && data ? (
          <AdminTable headers={["Name", "Email", "Role", "Status", "Joined"]}>
            {data.map((member) => (
              <tr key={member.id}>
                <td className="px-4 py-3 font-medium text-ink">{member.profiles?.full_name || "Unnamed"}</td>
                <td className="px-4 py-3">{member.profiles?.email}</td>
                <td className="px-4 py-3">{titleCase(member.role)}</td>
                <td className="px-4 py-3"><Badge tone={statusTone(member.status)}>{member.status}</Badge></td>
                <td className="px-4 py-3">{formatDateTime(member.created_at)}</td>
              </tr>
            ))}
          </AdminTable>
        ) : null}
      </AdminPanel>
    </div>
  );
}
